import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import api from '@services/api';

const options: ApexOptions = {
  plotOptions: {
    bar: {
      borderRadius: 10,
      dataLabels: {
        position: 'center',
      },
    },
  },
  chart: {
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      export: {
        csv: {
          filename: 'registeredDevices',
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
        },
        svg: {
          filename: 'registeredDevices',
        },
        png: {
          filename: 'registeredDevices',
        },
      },
      autoSelected: 'zoom',
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [],
    type: 'category',
    tickAmount: 'dataPoints',
    position: 'bottom',
    min: undefined,
    max: undefined,
    axisBorder: {
      show: true,
    },
    labels: {
      rotate: -50,
      show: true,
      trim: true,
      style: {
        colors: '#1b71af',
        fontSize: '11px',
        fontFamily: 'Montserrat',
        fontWeight: 500,
      },
    },
  },
  yaxis: {
    labels: {
      show: true,
    },
  },
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: true,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: 'dark',
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
  },
  series: [
    {
      name: 'Registered Device Connections Number',
      data: [],
    },
  ],
};

const RegisteredDevices = () => {
  const [chart, setChart] = React.useState(options);

  React.useEffect(() => {
    api.reports.getRegisteredDevicesReport({ numberOfDays: 30 }).then((elements) => {
      if (elements?.length) {
        const graph = elements?.map(({ date }) => date);
        const number = elements?.map(({ registeredDevices }) => registeredDevices!);
        setChart({
          ...chart,
          series: [
            {
              ...chart.series,
              data: number,
            },
          ],
          xaxis: {
            ...chart.xaxis,
            categories: graph,
          },
        });
      } else {
        setChart({
          ...chart,
          noData: {
            ...chart.noData,
            text: 'No Data',
            style: {
              color: '#0080FFDD',
              fontSize: '25px',
              fontFamily: 'Montserrat',
            },
          },
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ReactApexChart options={chart} series={chart.series} type="bar" height={400} />
    </div>
  );
};
export default React.memo(RegisteredDevices);
